import { render, staticRenderFns } from "./sendEmailsAction.vue?vue&type=template&id=40c95978&"
import script from "./sendEmailsAction.vue?vue&type=script&lang=js&"
export * from "./sendEmailsAction.vue?vue&type=script&lang=js&"
import style0 from "./sendEmailsAction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports